var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F4A026"
    },
    cx: 42.207,
    cy: 93.179,
    r: 29.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.373,
    y: 63.791,
    style: {
      fill: "#F4A026"
    },
    width: 376.614,
    height: 58.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#61ACD2"
    },
    cx: 42.207,
    cy: 255.513,
    r: 29.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.373,
    y: 226.124,
    style: {
      fill: "#61ACD2"
    },
    width: 376.614,
    height: 58.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CA463D"
    },
    cx: 42.207,
    cy: 417.847,
    r: 29.22
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.373,
    y: 388.458,
    style: {
      fill: "#CA463D"
    },
    width: 376.614,
    height: 58.44
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.207,50.973C18.933,50.973,0,69.907,0,93.179s18.933,42.207,42.207,42.207s42.207-18.935,42.207-42.207 S65.48,50.973,42.207,50.973z M42.207,109.413c-8.952,0-16.233-7.282-16.233-16.233s7.282-16.233,16.233-16.233 S58.44,84.228,58.44,93.179S51.158,109.413,42.207,109.413z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512,64.933c0-7.173-5.814-12.987-12.987-12.987H122.399c-7.173,0-12.987,5.814-12.987,12.987v58.44 c0,7.173,5.814,12.987,12.987,12.987h376.614c7.173,0,12.987-5.814,12.987-12.987V64.933z M486.027,110.387h-350.64V77.92h350.64 V110.387z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.207,213.306C18.933,213.306,0,232.241,0,255.513s18.933,42.207,42.207,42.207s42.207-18.935,42.207-42.207 S65.48,213.306,42.207,213.306z M42.207,271.746c-8.952,0-16.233-7.282-16.233-16.233s7.282-16.233,16.233-16.233 s16.233,7.282,16.233,16.233S51.158,271.746,42.207,271.746z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M512,227.267c0-7.173-5.814-12.987-12.987-12.987H122.399c-7.173,0-12.987,5.814-12.987,12.987v58.44 c0,7.173,5.814,12.987,12.987,12.987h376.614c7.173,0,12.987-5.814,12.987-12.987V227.267z M486.027,272.72h-350.64v-32.467h350.64 V272.72z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.207,375.64C18.933,375.64,0,394.574,0,417.847s18.933,42.207,42.207,42.207s42.207-18.935,42.207-42.207 S65.48,375.64,42.207,375.64z M42.207,434.08c-8.952,0-16.233-7.282-16.233-16.233s7.282-16.233,16.233-16.233 s16.233,7.282,16.233,16.233S51.158,434.08,42.207,434.08z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M512,389.601c0-7.173-5.814-12.987-12.987-12.987H122.399c-7.173,0-12.987,5.814-12.987,12.987v58.44 c0,7.173,5.814,12.987,12.987,12.987h376.614c7.173,0,12.987-5.814,12.987-12.987V389.601z M486.027,435.054h-350.64v-32.467h350.64 V435.054z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.9aad8a2e6fec422e3bdfffb6b2bd5824.svg";
export { ForwardRef as ReactComponent };